import tinycolor from 'tinycolor2'
import Platform from '../Platform'
import CSInterface, { SystemPath } from './CSInterface'
import { placeImages, syncSelections } from './helpers'

export default class App extends Platform {
  constructor() {
    super({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      supportedInsertFileTypes: ['svg'],
    })
  }

  init() {
    // CSInterface Object Global load first as we will load manifest and all
    const cs = new CSInterface()
    window.cs = cs
    // Load Dependencies in Adobe
    // Such as JSON
    const extensionRoot =
      window.cs.getSystemPath(SystemPath.EXTENSION) + '/host/'
    window.cs.evalScript('$.evalFile("' + extensionRoot + 'json.jsx' + '")')

    this.platform =
      'adobe-' + window.cs.getHostEnvironment().appId.toLocaleLowerCase()

    // Sync From Tool is supported in Adobe Illustrator
    if (window.cs.getHostEnvironment().appId.toLocaleLowerCase() === 'ilst') {
      this.features.syncFromTool = true
    }

    // Load Plugin Settings and log into Analytics
    if (window.loadPlugin) {
      window.loadPlugin()
    }
  }

  insertItem(file) {
    console.log('insertItem', file)
    placeImages([file])
  }

  insertItems(files) {
    console.log('insertItems', files)
    const imgfiles = [1, 2, 5, 40, 45, 50, 23, 63, 23, 12].map(i => ({
      url: `https://photographs-dev.s3.wasabisys.com/photo/free/thumb/${i}.jpg`,
      name: 'tarun',
      format: 'jpg',
    }))

    placeImages(imgfiles)
  }

  openURL(url) {
    window.cs.openURLInDefaultBrowser(url)
  }

  async syncSelection(uuid, token) {
    await syncSelections(uuid, token)
  }

  fillColor(color) {
    const colorRGB = tinycolor(color).toRgb()
    const script = `var selectedItems = app.activeDocument.selection;
    var fillColor = new RGBColor();
    fillColor.red = ${colorRGB.r};
    fillColor.green = ${colorRGB.g};
    fillColor.blue = ${colorRGB.b};

    for (i = 0; i < selectedItems.length; i++) {
      if (selectedItems[i].filled) {
        selectedItems[i].fillColor = fillColor;
        selectedItems[i].opacity = ${colorRGB.a * 100};
      }
    }
    `
    window.cs.evalScript(script)
  }

  fillBorderColor(color) {
    const colorRGB = tinycolor(color).toRgb()
    const script = `var selectedItems = app.activeDocument.selection;
    var fillColor = new RGBColor();
    fillColor.red = ${colorRGB.r};
    fillColor.green = ${colorRGB.g};
    fillColor.blue = ${colorRGB.b};

    for (i = 0; i < selectedItems.length; i++) {
      if (selectedItems[i].filled) {
        selectedItems[i].strokeColor = fillColor;
      }
    }
    `
    window.cs.evalScript(script)
  }
}
